import styled from "styled-components";

interface ContainerProps {
  columns: number;
}

interface UnityProps {
  corUnidadeFundo?: string;
  zoomLevel: number;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  width: 100%;
  height: 100%;
  overflow-x: auto;

  &::-webkit-scrollbar-thumb {
    background-color: #a3a3a6;
    border-radius: 8px;
  }
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-track {
    border-radius: 8px;
  }
`;

export const ContainerFlex = styled.div`
  display: flex;
  gap: 10px;
  padding: 16px;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  align-items: center;
  justify-content: center;

  &::-webkit-scrollbar-thumb {
    background-color: #a3a3a6;
    border-radius: 8px;
  }
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-track {
    border-radius: 8px;
  }
`;

export const FloorRow = styled.div`
  display: flex;
  gap: 14px;
  width: 100%;
`;

export const FloorLabel = styled.div<UnityProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-family: Inter;
  font-size: ${(props) => 16 * props.zoomLevel}px;
  border: 1px solid #d5d5d5;
  padding: 8px;
  height: ${(props) => 48 * props.zoomLevel}px;
  width: ${(props) => 48 * props.zoomLevel}px;
  min-width: ${(props) => 48 * props.zoomLevel}px;
  border-radius: 8px;
  text-align: center;
`;

export const UnitGrid = styled.div<ContainerProps>`
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
`;

export const Unity = styled.button<UnityProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  border: 1px solid #d5d5d5;
  background-color: ${(props) => `rgb(${props.corUnidadeFundo})` || "#fff"};
  width: ${(props) => 90 * props.zoomLevel}px;
  height: ${(props) => 48 * props.zoomLevel}px;
  cursor: pointer;

  :hover {
    opacity: 0.3;
  }
`;

export const UnityText = styled.p<any>`
  color: #303030;
  font-family: Inter;
  font-size: ${(props) => 12 * props.zoomLevel}px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -0.08px;
  color: ${(props) => `rgb(${props.corUnidadeTexto})` || "#333"};
  text-align: center;
`;

export const TableTextHeader: any = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 11.44px;
  text-align: left;
`;

export const TableTextBody: any = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 11.44px;
  text-align: left;
  color: black;
`;

export const tooltipComponentsProps = {
  tooltip: {
    sx: {
      backgroundColor: "#4a4a4a",
      borderRadius: "10px",
      padding: "6px 12px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.25)",
      maxWidth: "none",
    },
  },
  arrow: {
    sx: {
      color: "#4a4a4a",
    },
  },
};

export const TooltipContent: any = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  line-height: 1.25;
  white-space: nowrap;
`;

export const TooltipTitle: any = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
`;

export const TooltipDetails: any = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
`;

export const TooltipDate: any = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: #bdbdbd;
`;
